<div class="dialog-panel">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-header">
        <h1 class="dialog-title dot">{{ 'global.update_details' | transloco }}</h1>
      </div>
      <div class="dialog-body">
        @for (formControl of form.controls | keyvalue; track formControl) {
          <div class="form-field-container">
            <div class="form-field-label">
              {{ 'form.field.' + formControl.key | transloco }}
            </div>
            <mat-form-field class="form-field" [floatLabel]="'auto'">
              <input matInput [formControlName]="formControl.key" required />
              @if (getFormControl(formControl.key).invalid) {
                <mat-error>
                  @if (getFormControl(formControl.key).errors.required) {
                    {{ 'form.error.required' | transloco }}
                  }
                  @if (getFormControl(formControl.key).errors.email) {
                    {{ 'form.error.invalid_email' | transloco }}
                  }
                  @if (getFormControl(formControl.key).errors.alreadyExist) {
                    {{ 'form.error.user_already_exist' | transloco }}
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
        }
      </div>
      <div class="dialog-bottom">
        <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
          {{ 'global.signin' | transloco }}
        </button>
      </div>
    </form>
  </div>
</div>
